<template>
  <b-row>
    <b-col cols="12" md="12">
      <b-row>
        <b-col>
          <b-alert v-if="quoteId" variant="info" show>
            <strong>
              <i class="fa fa-info-circle" />
              {{ $lang.quoteEditAlert }}
            </strong>
          </b-alert>
        </b-col>
      </b-row>
      <b-overlay :show="loading" rounded="sm">
        <b-row>
          <b-col cols="12" md="6" class="mt-3 new_register">
            <requiredComponent
              slot="label"
              tag="strong"
              :label="`${$lang.quotaStatusMore}:`"
              :rules="$v.form.sacrificerTypeSelected.$params"
            />
            <b-form-radio-group
              class="mt-2 quotaStatusMore"
              v-model="$v.form.sacrificerTypeSelected.$model"
              :options="quotaStatusMore"
              name="quotaStatusMore"
              stacked
            >
              <b-form-invalid-feedback
                :state="
                  $v.form.sacrificerTypeSelected.$dirty
                    ? !$v.form.sacrificerTypeSelected.$error
                    : null
                "
              >
                {{ $lang.error_required | replace($lang.quotaStatusMore) }}
              </b-form-invalid-feedback>
            </b-form-radio-group>
          </b-col>
          <b-col cols="12" md="6" class="border-right left_form mt-3">
            <b-row class="mb-3">
              <b-col tag="strong" v-text="`${$lang.sacrificer_info}: `" />
            </b-row>
            <b-row align-v="center" class="mb-2">
              <b-col>
                <b-form-group
                  class="mb-0"
                  :label="`${$lang.name}:`"
                  label-for="quota_field_1"
                  label-cols-md="5"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.name}:`"
                    :rules="$v.form.sacrificerName.$params"
                  />
                  <b-form-input
                    v-model="$v.form.sacrificerName.$model"
                    type="text"
                    id="quota_field_1"
                    :state="
                      $v.form.sacrificerName.$dirty
                        ? !$v.form.sacrificerName.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :state="
                      $v.form.sacrificerName.$dirty
                        ? !$v.form.sacrificerName.$error
                        : null
                    "
                  >
                    {{ $lang.error_required | replace($lang.name) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-v="center" class="mb-2">
              <b-col>
                <b-form-group
                  class="mb-0"
                  :label="`${$lang.family}:`"
                  label-for="quota_field_2"
                  label-cols-md="5"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.family}:`"
                    :rules="$v.form.sacrificerFamily.$params"
                  />
                  <b-form-input
                    v-model="$v.form.sacrificerFamily.$model"
                    type="text"
                    id="quota_field_2"
                    :state="
                      $v.form.sacrificerFamily.$dirty
                        ? !$v.form.sacrificerFamily.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :state="
                      $v.form.sacrificerFamily.$dirty
                        ? !$v.form.sacrificerFamily.$error
                        : null
                    "
                  >
                    {{ $lang.error_required | replace($lang.family) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-v="center" class="mb-2">
              <b-col>
                <b-form-group
                  class="mb-0"
                  :label="`${$lang.national_code}:`"
                  label-for="quota_field_3"
                  label-cols-md="5"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.national_code}:`"
                    :rules="$v.form.sacrificerNationalCode.$params"
                  />
                  <b-form-input
                    v-model="$v.form.sacrificerNationalCode.$model"
                    type="text"
                    id="quota_field_3"
                    maxLength="10"
                    :state="
                      $v.form.sacrificerNationalCode.$dirty
                        ? !$v.form.sacrificerNationalCode.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :state="
                      $v.form.sacrificerNationalCode.$dirty
                        ? !$v.form.sacrificerNationalCode.$error
                        : null
                    "
                  >
                    <div v-if="!$v.form.sacrificerNationalCode.required">
                      {{ $lang.error_required | replace($lang.national_code) }}
                    </div>
                    <div v-if="!$v.form.sacrificerNationalCode.maxLength">
                      {{ $lang.error_max | replace($lang.national_code, 10) }}
                    </div>
                    <div v-if="!$v.form.sacrificerNationalCode.minLength">
                      {{ $lang.error_max | replace($lang.national_code, 10) }}
                    </div>
                    <div v-if="!$v.form.sacrificerNationalCode.numeric">
                      {{ $lang.error_numeric | replace($lang.national_code) }}
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-v="center" class="mb-2">
              <b-col>
                <b-form-group
                  class="mb-0"
                  :label="`${$lang.birth_certificate}:`"
                  label-for="quota_field_4"
                  label-cols-md="5"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.birth_certificate}:`"
                    :rules="$v.form.sacrificerIdNumber.$params"
                  />
                  <b-form-input
                    v-model="$v.form.sacrificerIdNumber.$model"
                    type="text"
                    id="quota_field_4"
                    maxLength="10"
                    :state="
                      $v.form.sacrificerIdNumber.$dirty
                        ? !$v.form.sacrificerIdNumber.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :state="
                      $v.form.sacrificerIdNumber.$dirty
                        ? !$v.form.sacrificerIdNumber.$error
                        : null
                    "
                  >
                    <div v-if="!$v.form.sacrificerIdNumber.required">
                      {{
                        $lang.error_required | replace($lang.birth_certificate)
                      }}
                    </div>
                    <div v-if="!$v.form.sacrificerIdNumber.maxLength">
                      {{
                        $lang.error_max | replace($lang.birth_certificate, 10)
                      }}
                    </div>
                    <div v-if="!$v.form.sacrificerIdNumber.numeric">
                      {{
                        $lang.error_numeric | replace($lang.birth_certificate)
                      }}
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-v="center" class="mb-2">
              <b-col>
                <b-form-group
                  class="mb-0"
                  :label="`${$lang.father_name}:`"
                  label-for="quota_field_5"
                  label-cols-md="5"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.father_name}:`"
                    :rules="$v.form.sacrificerFatherName.$params"
                  />
                  <b-form-input
                    v-model="$v.form.sacrificerFatherName.$model"
                    type="text"
                    id="quota_field_5"
                    :state="
                      $v.form.sacrificerFatherName.$dirty
                        ? !$v.form.sacrificerFatherName.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :state="
                      $v.form.sacrificerFatherName.$dirty
                        ? !$v.form.sacrificerFatherName.$error
                        : null
                    "
                  >
                    {{ $lang.error_required | replace($lang.father_name) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-v="center" class="mb-2">
              <b-col>
                <b-form-group
                  class="mb-0"
                  :label="`${$lang.birth_date}:`"
                  label-for="quota_field_6"
                  label-cols-md="5"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.birth_date}:`"
                    :rules="$v.form.sacrificerBirthDate.$params"
                  />
                  <date-picker
                    v-model="$v.form.sacrificerBirthDate.$model"
                    display-format="jYYYY/jMM/jDD"
                    format="YYYY-MM-DD"
                    type="date"
                    id="quota_field_6"
                    clearable
                    :placeholder="$lang.date_placeholder"
                  />
                  <b-form-invalid-feedback
                    :state="
                      $v.form.sacrificerBirthDate.$dirty
                        ? !$v.form.sacrificerBirthDate.$error
                        : null
                    "
                  >
                    {{ $lang.error_required | replace($lang.birth_date) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-v="center" class="mb-2">
              <b-col>
                <b-form-group
                  class="mb-0"
                  :label="`${$lang.quotaCode}:`"
                  label-for="quota_field_7"
                  label-cols-md="5"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.quotaCode}:`"
                    :rules="$v.form.sacrificerCode.$params"
                  />
                  <b-form-input
                    v-model="$v.form.sacrificerCode.$model"
                    type="number"
                    id="quota_field_7"
                    :state="
                      $v.form.sacrificerCode.$dirty
                        ? !$v.form.sacrificerCode.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :state="
                      $v.form.sacrificerCode.$dirty
                        ? !$v.form.sacrificerCode.$error
                        : null
                    "
                  >
                    {{ $lang.error_required | replace($lang.quotaCode) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-v="center" class="mb-2">
              <b-col>
                <b-form-group
                  class="mb-0"
                  :label="`${$lang.sacrificerPreCode}:`"
                  label-for="quota_field_8"
                  label-cols-md="5"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.sacrificerPreCode}:`"
                    :rules="$v.form.sacrificerPreCode.$params"
                  />
                  <b-form-input
                    v-model="$v.form.sacrificerPreCode.$model"
                    type="number"
                    id="quota_field_8"
                    :state="
                      $v.form.sacrificerPreCode.$dirty
                        ? !$v.form.sacrificerPreCode.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :state="
                      $v.form.sacrificerPreCode.$dirty
                        ? !$v.form.sacrificerPreCode.$error
                        : null
                    "
                  >
                    <div v-if="!$v.form.sacrificerNationalCode.numeric">
                      {{
                        $lang.error_numeric | replace($lang.sacrificerPreCode)
                      }}
                    </div>
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-v="center" class="mb-2">
              <b-col>
                <b-form-group
                  class="mb-0"
                  :label="`${$lang.duration_presence_front_month}:`"
                  label-for="quota_field_9"
                  label-cols-md="5"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.duration_presence_front_month}:`"
                    :rules="$v.form.sacrificerTime.$params"
                  />
                  <b-form-input
                    v-model="$v.form.sacrificerTime.$model"
                    type="number"
                    id="quota_field_9"
                    :state="
                      $v.form.sacrificerTime.$dirty
                        ? !$v.form.sacrificerTime.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :state="
                      $v.form.sacrificerTime.$dirty
                        ? !$v.form.sacrificerTime.$error
                        : null
                    "
                  >
                    {{
                      $lang.error_required
                        | replace($lang.duration_presence_front)
                    }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-v="center" class="mb-2">
              <b-col>
                <b-form-group
                  class="mb-0"
                  :label="`${$lang.description}:`"
                  label-for="quota_field_10"
                  label-cols-md="5"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.description}:`"
                    :rules="$v.form.sacrificerDescription.$params"
                  />
                  <b-form-textarea
                    v-model="$v.form.sacrificerDescription.$model"
                    id="quota_field_10"
                    :isValid="
                      $v.form.sacrificerDescription.$dirty
                        ? !$v.form.sacrificerDescription.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :state="
                      $v.form.sacrificerDescription.$dirty
                        ? !$v.form.sacrificerDescription.$error
                        : null
                    "
                  >
                    {{ $lang.error_required | replace($lang.description) }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row align-v="center" class="mb-2">
              <b-col>
                <b-form-group
                  class="mb-0"
                  :label="`${$lang.sacrificerCompany}:`"
                  label-for="quota_field_11"
                  label-cols-md="5"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.sacrificerCompany}:`"
                    :rules="$v.form.sacrificerCompanySelected.$params"
                  />
                  <selectFind
                    :options="sacrificerCompany"
                    v-model="$v.form.sacrificerCompanySelected.$model"
                    label="text"
                    :isValid="
                      $v.form.sacrificerCompanySelected.$dirty
                        ? !$v.form.sacrificerCompanySelected.$error
                        : null
                    "
                    :loading="status.sacrificerCompany"
                  />
                  <b-form-invalid-feedback
                    :state="
                      $v.form.sacrificerCompanySelected.$dirty
                        ? !$v.form.sacrificerCompanySelected.$error
                        : null
                    "
                  >
                    {{
                      $lang.error_required | replace($lang.sacrificerCompany)
                    }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row
              align-v="center"
              class="mb-2"
              v-if="
                pathOr(null, ['sacrificerCompanySelected', 'value'], form) === 8
              "
            >
              <b-col>
                <b-form-group
                  class="mb-0"
                  :label="`${$lang.other_cases}:`"
                  label-for="quota_field_12"
                  label-cols-md="5"
                >
                  <requiredComponent
                    slot="label"
                    :label="`${$lang.other_cases}:`"
                    :rules="$v.form.sacrificerCompanyDescription.$params"
                  />
                  <b-form-textarea
                    v-model="$v.form.sacrificerCompanyDescription.$model"
                    id="quota_field_12"
                    :isValid="
                      $v.form.sacrificerCompanyDescription.$dirty
                        ? !$v.form.sacrificerCompanyDescription.$error
                        : null
                    "
                  />
                  <b-form-invalid-feedback
                    :state="
                      $v.form.sacrificerCompanyDescription.$dirty
                        ? !$v.form.sacrificerCompanyDescription.$error
                        : null
                    "
                  >
                    {{
                      $lang.error_required | replace($lang.sacrificerCompany)
                    }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row>
          <b-col class="text-right mt-4">
            <b-overlay
              :show="loading"
              spinner-small
              spinner-variant="success"
              class="d-inline-block"
            >
              <b-button
                variant="success"
                @click="putPersonAllotment"
                :disabled="loading"
              >
                <mdicon name="check" size="20" />
                {{ (quoteId && $lang.edit_info) || $lang.register_info }}
              </b-button>
            </b-overlay>
          </b-col>
        </b-row>
      </b-overlay>
    </b-col>
  </b-row>
</template>
<script>
import { renderEumOptions } from "@/shared/utils";
import { pathOr } from "ramda";
import {
  required,
  requiredIf,
  minLength,
  maxLength,
  numeric,
} from "vuelidate/lib/validators";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

export default {
  name: "quote-info",
  components: {
    datePicker: VuePersianDatetimePicker,
  },
  validations: {
    form: {
      sacrificerTypeSelected: {
        required,
      },
      sacrificerName: {
        required,
      },
      sacrificerFamily: {
        required,
      },
      sacrificerNationalCode: {
        required,
        numeric,
        minLength: minLength(10),
        maxLength: maxLength(10),
      },
      sacrificerIdNumber: {
        required,
        numeric,
        maxLength: maxLength(10),
      },
      sacrificerFatherName: {
        required,
      },
      sacrificerBirthDate: {
        required,
      },
      sacrificerCode: {
        required,
      },
      sacrificerPreCode: {
        numeric,
      },
      sacrificerTime: {
        required,
      },
      sacrificerCompanySelected: {
        required,
      },
      sacrificerCompanyDescription: {
        requiredIf: requiredIf((vm) => {
          return !!(
            pathOr(null, ["sacrificerCompanySelected", "value"], vm) === 8
          );
        }),
      },
      sacrificerDescription: {},
    },
  },
  props: {
    code: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      quoteId: null,
      form: {
        sacrificerTypeSelected: null,
        sacrificerName: null,
        sacrificerFamily: null,
        sacrificerNationalCode: null,
        sacrificerIdNumber: null,
        sacrificerFatherName: null,
        sacrificerBirthDate: null,
        sacrificerCode: null,
        sacrificerPreCode: null,
        sacrificerTime: null,
        sacrificerCompanySelected: null,
        sacrificerCompanyDescription: null,
        sacrificerDescription: null,
      },
      status: {
        sacrificerCompany: false,
      },
    };
  },
  computed: {
    quotaStatusMore() {
      return renderEumOptions("sacrificer_type");
    },
    sacrificerCompany() {
      return renderEumOptions("sacrificer_organize");
    },
  },
  created() {
    this.getPersonAllotment();
  },
  methods: {
    pathOr,
    async getPersonAllotment() {
      this.loading = true;
      const url =
        this.$config.api_url +
        this.$config.profile.person_allotment.replace(
          "{person_code}",
          this.code
        );
      try {
        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.quoteId = pathOr(null, ["id"], data);
        this.$emit("getPermissions", response.data.permissions);
        this.form.sacrificerTypeSelected = pathOr(
          null,
          ["sacrificer_type", "id"],
          data
        );
        this.form.sacrificerName = pathOr(null, ["sacrificer_name"], data);
        this.form.sacrificerFamily = pathOr(null, ["sacrificer_family"], data);
        this.form.sacrificerNationalCode = pathOr(
          null,
          ["sacrificer_national_code"],
          data
        );
        this.form.sacrificerIdNumber = pathOr(
          null,
          ["sacrificer_identify"],
          data
        );
        this.form.sacrificerFatherName = pathOr(
          null,
          ["sacrificer_father_name"],
          data
        );
        this.form.sacrificerBirthDate = pathOr(
          null,
          ["sacrificer_birth_date", "gregorian"],
          data
        );
        this.form.sacrificerCode = pathOr(null, ["sacrificer_code"], data);
        this.form.sacrificerPreCode = pathOr(
          null,
          ["sacrificer_pre_code"],
          data
        );
        this.form.sacrificerTime = pathOr(null, ["sacrificer_duration"], data);
        this.form.sacrificerCompanySelected = {
          value: pathOr(null, ["sacrificer_organize", "id"], data),
          text: pathOr(null, ["sacrificer_organize", "caption"], data),
        };
        this.form.sacrificerCompanyDescription = pathOr(
          null,
          ["organize_description"],
          data
        );
        this.form.sacrificerDescription = pathOr(null, ["description"], data);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
    async putPersonAllotment() {
      this.$v.$touch();
      if (this.$v.$anyError) {
        return;
      }
      this.loading = true;
      let url =
        this.$config.api_url +
        this.$config.profile.person_allotment.replace(
          "{person_code}",
          this.code
        );
      if (this.quoteId) {
        url += `?id=${this.quoteId}`;
      }
      try {
        const payload = {
          sacrificer_type_id: this.form.sacrificerTypeSelected,
          sacrificer_name: this.form.sacrificerName,
          sacrificer_family: this.form.sacrificerFamily,
          sacrificer_national_code: this.form.sacrificerNationalCode,
          sacrificer_identify: this.form.sacrificerIdNumber,
          sacrificer_father_name: this.form.sacrificerFatherName,
          sacrificer_birth_date: this.form.sacrificerBirthDate,
          sacrificer_code: this.form.sacrificerCode,
          sacrificer_pre_code: this.form.sacrificerPreCode,
          sacrificer_duration: this.form.sacrificerTime,
          sacrificer_organize_id: this.form.sacrificerCompanySelected.value,
          organize_description: this.form.sacrificerCompanyDescription,
          description: this.form.sacrificerDescription,
        };
        const response = await this.$httpService.put(url, payload);
        this.quoteId = pathOr(null, ["data", "data"], response);
        this.$notify.success(response.data.message);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 575.98px) {
  .left_form {
    border-right: none !important;
  }
}

.new_register
  .custom-control-input:focus
  ~ .new_register
  .custom-control-label::before,
.new_register
  .custom-control-input:focus:not(:checked)
  ~ .custom-control-label::before {
  box-shadow: none;
  border-color: #c7cdd3;
}
.new_register .custom-checkbox .custom-control-label::before {
  border-radius: 4px;
}
.new_register .custom-radio .custom-control-label::before {
  border-radius: 25px;
}

.new_register .custom-control-label::before {
  background-image: none;
  border: 2px solid #c7cdd3;
  background-color: transparent;
}
.new_register
  .custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::after {
  border-radius: 4px;
  box-shadow: none;
}
.new_register
  .custom-radio
  .custom-control-input:checked
  ~ .custom-control-label::after {
  border-radius: 25px;
  box-shadow: none;
}

.new_register .custom-control-input:checked ~ .custom-control-label::after {
  background-image: none;
  border: 2px solid #c7cdd3;
  border-radius: 25px;
  background-color: transparent;
}
.new_register .custom-control-input:checked ~ .custom-control-label::before {
  background-color: transparent;
  background: transparent;
  color: transparent;
  border-top: 0;
  border-right: 0;
  border-bottom: 3px solid #00bcd4;
  border-left: 3px solid #00bcd4;
  content: "";
  width: 17px;
  height: 8px;
  border-radius: 0;
  transform: rotate(-45deg);
  position: absolute;
  top: 2px;
  right: -27px;
  z-index: 1;
  box-shadow: none;
}
</style>
